import { InjectionToken, ValueProvider } from '@angular/core';
import { AppConfig } from '../models/app-config';

export const APP_CONFIG = new InjectionToken<AppConfig>('movinmotion-frontend.app-config');

export const getAppConfigProvider = (value: AppConfig): ValueProvider => ({
  provide: APP_CONFIG,
  useValue: value,
});
